export default __webpack_public_path__ + "facebook-sqr-v1.svg";